new Vue({
  delimiters: ['[[', ']]'], // change because vue and django using the same args 
  el: '#app_list',
  data: {
    menuFilter: false,
    listOpened: false,
    listEx: localStorage.getItem('listOrder') ? localStorage.getItem('listOrder') : localStorage.setItem('listOrder', 0),
    listExMobile: localStorage.getItem('listOrderMobile') ? localStorage.getItem('listOrderMobile') : localStorage.setItem('listOrderMobile', 0),
    cartItems: (JSON.parse(localStorage.getItem('cartItems')) || []).map(item => item.original_sku.split('-').slice(0, -1).join('-')),
    thisSku: null
  },
  methods: {
    addBoughtClass() {
      const productItems = document.querySelectorAll('.product-item');
      
      productItems.forEach(item => {
          const itemSku = item.getAttribute('itemSku');
          
          if (this.cartItems.includes(itemSku)) {
              item.classList.add('already-bought');
          }
      });
    },
    buySize() {
      const filterSize = document.querySelector(".product-filter__item--size");
      if (filterSize) {
        const cloneFilterSize = filterSize.cloneNode(true);
        const elementDest = document.querySelector("#buy-sizes");
        if (cloneFilterSize && elementDest) {
          elementDest.append(cloneFilterSize);

          this.seeMoreSizes();
        }
      } else {
        document.querySelector('.product-list-size').style.display = 'none';
      }
    },
    seeMoreSizes() {
      const container = document.querySelector('#buy-sizes');
      if (!container) return; // Verifica se o container existe
  
      const ulMenu = container.querySelector('.product-filter__sub-menu');
      if (!ulMenu) return; // Verifica se o ul existe dentro do container
  
      const maxHeightPerTwoRows = 88; // 2 linhas = 88px (40px * 2 + 8px de gap)
      let currentMaxHeight = maxHeightPerTwoRows;
  
      // Função para verificar e ajustar a altura
      const checkAndAdjustHeight = () => {
          const totalHeight = ulMenu.scrollHeight; // Altura total de todo o conteúdo
  
          // Se a altura total for maior que o limite de 2 linhas
          if (totalHeight > currentMaxHeight) {
              ulMenu.style.height = `${currentMaxHeight}px`; // Define a altura máxima visível
              addShowMoreButton(); // Adiciona o botão "Ver mais"
          } else {
              ulMenu.style.height = 'auto'; // Se já couber, exibe tudo
          }
      };
  
      // Função para criar o botão "Ver mais"
      const addShowMoreButton = () => {
          let showMoreBtn = document.querySelector('.show-more-btn');
          if (!showMoreBtn) {
              showMoreBtn = document.createElement('button');
              showMoreBtn.className = 'show-more-btn';
              showMoreBtn.textContent = 'Ver mais';
              container.appendChild(showMoreBtn);
          }
  
          showMoreBtn.addEventListener('click', function () {
              currentMaxHeight += maxHeightPerTwoRows; // Aumenta mais duas linhas
              ulMenu.style.height = `${currentMaxHeight}px`;
  
              // Remove o botão se não houver mais itens para mostrar
              if (currentMaxHeight >= ulMenu.scrollHeight) {
                  showMoreBtn.remove();
              }
          });
      };
      
      // Executa o cálculo inicial
      checkAndAdjustHeight();
    },
    filterPrice() {
      //chamadas para o filtro de preço
      function controlFromInput(fromSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#CEB8A2', controlSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromSlider.value = from;
        }
      }

      function controlToInput(toSlider, fromInput, toInput, controlSlider) {
        const [from, to] = getParsed(fromInput, toInput);
        fillSlider(fromInput, toInput, '#E9E9E9', '#CEB8A2', controlSlider);
        setToggleAccessible(toInput);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
        }
      }

      function controlFromSlider(fromSlider, toSlider, fromInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#CEB8A2', toSlider);
        if (from > to) {
          fromSlider.value = to;
          fromInput.value = to;
        } else {
          fromInput.value = from;
        }
      }

      function controlToSlider(fromSlider, toSlider, toInput) {
        const [from, to] = getParsed(fromSlider, toSlider);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#CEB8A2', toSlider);
        setToggleAccessible(toSlider);
        if (from <= to) {
          toSlider.value = to;
          toInput.value = to;
        } else {
          toInput.value = from;
          toSlider.value = from;
        }
      }

      function getParsed(currentFrom, currentTo) {
        const from = parseInt(currentFrom.value, 10);
        const to = parseInt(currentTo.value, 10);
        return [from, to];
      }

      function fillSlider(from, to, sliderColor, rangeColor, controlSlider) {
        const rangeDistance = to.max - to.min;
        const fromPosition = from.value - to.min;
        const toPosition = to.value - to.min;
        controlSlider.style.background = `linear-gradient(
      to right,
      ${sliderColor} 0%,
      ${sliderColor} ${(fromPosition) / (rangeDistance) * 100}%,
      ${rangeColor} ${((fromPosition) / (rangeDistance)) * 100}%,
      ${rangeColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} ${(toPosition) / (rangeDistance) * 100}%, 
      ${sliderColor} 100%)`;
      }

      function setToggleAccessible(currentTarget) {
        const toSlider = document.querySelector('#toSlider');
        if (Number(currentTarget.value) <= 0) {
          toSlider.style.zIndex = 2;
        } else {
          toSlider.style.zIndex = 0;
        }
      }

      const fromSlider = document.querySelector('#fromSlider');
      const toSlider = document.querySelector('#toSlider');
      const fromInput = document.querySelector('#fromInput');
      const toInput = document.querySelector('#toInput');
      let url = window.location.href;
      
      if (url.includes('?lp=')) {
        const params = new URLSearchParams(window.location.search)
        const firstParams = params.get('lp');
        const secondParams = params.get('hp');
        fromInput.value = firstParams; 
        toInput.value = secondParams;
        fromSlider.setAttribute('value', firstParams);
        toSlider.setAttribute('value', secondParams);
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#CEB8A2', toSlider);
      } else {
        fillSlider(fromSlider, toSlider, '#E9E9E9', '#CEB8A2', toSlider);
        setToggleAccessible(toSlider);
      }

      fromSlider.oninput = () => controlFromSlider(fromSlider, toSlider, fromInput);
      toSlider.oninput = () => controlToSlider(fromSlider, toSlider, toInput);
      fromInput.oninput = () => controlFromInput(fromSlider, fromInput, toInput, toSlider);
      toInput.oninput = () => controlToInput(toSlider, fromInput, toInput, toSlider);

      function handleSliderRelease() {
        let from = $('#fromInput').val();
        let to = $('#toInput').val();
        window.location = `?lp=${from}&hp=${to}`;
      }

      $(fromSlider).mouseup(handleSliderRelease);
      $(fromSlider).on('touchend', handleSliderRelease);

      $(toSlider).mouseup(handleSliderRelease);
      $(toSlider).on('touchend', handleSliderRelease);
    },
    changeList(list) {
      this.listEx = list;
      localStorage.setItem('listOrder', list);
    },

    changeListMobile(list) {
      this.listExMobile = list;
      this.listOpened = false;
      localStorage.setItem('listOrderMobile', list);
    }
  },
  mounted() {
    if (!window.location.pathname.includes('/categoria/bones/')) {
      this.buySize()
    }
    this.filterPrice()
    this.addBoughtClass();
    
    window.addEventListener('storage', () => {
      const items = JSON.parse(localStorage.getItem('cartItems')) || [];
      this.updateCartPreview(items);
    });
  },
  watch: {
    menuFilter(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
    listOpened(newValue) {
      if (newValue) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.removeProperty('overflow');
      }
    },
  }
});

$(document).ready(function () {

  const productListInfo = document.querySelector('.product-list__info');
  if (productListInfo) {
    const description = productListInfo.querySelector('.description-categorie');
    if (description) {
      const toggle = description.querySelector('span');
      toggle.addEventListener('click', function() {
        productListInfo.classList.toggle('expanded');
        toggle.textContent = productListInfo.classList.contains('expanded') ? 'Ver menos' : 'Ver mais';
      });
    }
  }

  $('#product_list-7, #product_list-8, #product_list-9, #product_list-10, #product_list-11').slick({
    arrows: true,
    dots: false,
    infinite: false,
    mobileFirst: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    speed: 700,
    responsive: [
        {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
            }
        },
        {
            breakpoint: 991,
            settings: {
                arrows: true,
                slidesToShow: 4,
            }
        }
    ]
  }).on('afterChange', function(event, slick, currentSlide, nextSlide){
    Blazy({
        selector: '.lazy-img',
        successClass: 'loaded-img',
        success: function(element) {
            setTimeout(function(){
                var parent = element.previousSibling;
                try { parent.className = parent.className.replace(/\bproduct-item__image--loading\b/,''); } catch(e){}
            }, 200);
        }
    });
});

});